import { http } from 'vue'

export default {
  postAccessory (context, params = {}) {
    return http.post('company_sku_accessories?company_id=' + params.companyId, params.data)
  },
  putAccessory (context, params = {}) {
    return http.put('company_sku_accessories/' + params.id + '?company_id=' + params.companyId, params.data)
  },
  deleteAccessory (context, params = {}) {
    return http.delete('company_sku_accessories/' + params.id + '?company_id=' + params.companyId)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/accessories/actions.js